export const PROGRESS = {
  ALL: '전체',
  IN_PROGRESS: '응모 중',
  PENDING: '응모 전',
  COMPLETED: '응모 마감',
};
